import Layout from "layout/layout";

import { useEffect, useState } from "react";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi } from "utils";

import { Card } from "components/ui/card";
import SinglePageCenter from "layout/single-page-center/SinglePageCenter";
import SelectOneRadioOption from "components/app/function/SelectOneRadioOption";
import RadioGroupWithLabel from "components/app/function/RadioGroupWithLabel";
import { Button } from "components/ui/button";

export default function ClockTime() {
  const { token } = useAppSelector((state) => state.auth);

  // const fetchGetUserShopProfile = async () => {
  //   try {
  //     setLoadingShops(true);
  //     let url: string = "";
  //     url = RouteApi.getAccountShopDetail;
  //     url += `token=${token}`;

  //     const data = {
  //       shop_id: shopId,
  //     };

  //     const response = await RequestApi(url, { data });
  //     if (response.status === "success") {
  //       dispatch(setUserShopProfile(response["user_shop"]));
  //       dispatch(setCategories(response["categories"]));
  //     } else {
  //       AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
  //     }
  //   } catch (error) {
  //     AppLog.show({
  //       message: `[fetchGetUserShopProfile]`,
  //       status: StatusMsg.error,
  //       error,
  //     });
  //   } finally {
  //     setLoadingShops(false);
  //   }
  // };
  // "Clock Time (In)", "Clock Time (Break Out)", "Clock Time (Break In)", "Clock Time (Out)"
  return (
    <SinglePageCenter>
      <div className="space-y-4">
        <h1 className="font-semibold text-lg">Choose Check In/Out Time</h1>
        <RadioGroupWithLabel
          value=""
          onChange={(value) => {
            console.log("value", value);
          }}
          items={[
            { id: "Clock Time (In)", label: "Clock Time (In)", value: "Clock Time (In)" },
            { id: "Clock Time (Break Out)", label: "Clock Time (Break Out)", value: "Clock Time (Break Out)" },
            { id: "Clock Time (Break In)", label: "Clock Time (Break In)", value: "Clock Time (Break In)" },
            { id: "Clock Time (Out)", label: "Clock Time (Out)", value: "Clock Time (Out)" },
          ]}
        />
        <Button className="w-full">Done</Button>
      </div>
    </SinglePageCenter>
  );
}
